import React, { useState } from 'react';

import { 
  Encounter, 
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SettingsButton from '@components/input/buttons/icon_buttons/SettingsButton';
import FlexBox from '@components/layout/FlexBox';

interface Props {
  encounter: Encounter;
}

export default function EncounterSettingsButton({
  encounter,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        <FlexBox direction="column">
          <FlexBox className="header centered">
            Encounter Settings
          </FlexBox>
          <FlexBox>
            Currently there's nothing here, but we have plans to add the ability to switch to different types of encounters, 
            with appropriate tools to help with those encounter types. 
          </FlexBox>
          <FlexBox>
            Planned Encounter Types: 
          </FlexBox>
          <FlexBox>
            Combat - what we have now.
          </FlexBox>
          <FlexBox>
            Chase - more specific to chase mechanics, with hazards and position tracking.
          </FlexBox>
          <FlexBox>
            Skill Challenge - 
            tools for calling for different types of skill checks, group vs individual checks,
            tracking rolls of players, 
            appropriate consequences of failures, etc.
          </FlexBox>
          <FlexBox>
            Social - 
            this one keeps track of various NPCs and organizations they're part of, 
            with tools for tracking how they feel toward the party and each individual in it, 
            as well as toward other groups and individuals.
            It also has tools for types of checks that can be done when interacting with them 
            and appropriate responses in consequence to success or failure.
          </FlexBox>
        </FlexBox>
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <SettingsButton
        onClick={() => { setOpen(true); }}
      />
      { renderExtras() }
    </>
  ); 
}

